module.exports = __webpack_public_path__ + "img/red-check.c6cfd8cd.svg";